/* eslint-disable consistent-return */
import React, { useContext, useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import { connect } from "react-redux";
import { ModalContext } from "App";
import Modal from "modules/common/components/Modal";
import PropTypes from "prop-types";
import useFormValidator from 'useFormValidator';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import LoginContainerModal from "modules/auth/modals/LoginContainerModal";
import CmsContext from "../../../../CmsContext";
import MultiFactorAuthenticationEmail from "./components/MultiFactorAuthenticationEmail";
import AuthenticatorSetup from "./components/AuthenticatorSetup";
import MultiFactorAuthenticationSms from "./components/MultiFactorAuthenticationSms";

import * as actions from "../../actions";
import * as c from "../../constants";

function MfaModal({
  clearAttemp,
  serviceList,
  profile,
}) {
  const cmsContext = useContext(CmsContext);
  const CMS_LOGOS = cmsContext.findByType("LOGOS");
  const CMS_VARIABLES = cmsContext.findByType("VARIABLES");
  const CMS_COMPONENTS = cmsContext.findByType("COMPONENTS");
  const [selectedMfa, setSelectedMfa] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isResendTimerOTP, setIsResendTimerOTP] = useState(false);
  const [cooldownTime, setCooldownTime] = useState(() => {
    const storedCooldown = localStorage.getItem("cooldownTime");
    return storedCooldown ? Number.parseInt(storedCooldown, 10) : 0;
  });

  const [formData, setFormData] = useState({
    preferred_mfa: profile.preferred_mfa || '',
    title: ''
  });
  const setModal = useContext(ModalContext);
  const [isEmail] = useState("mobile");

  const formValidator = useFormValidator(formData, {
    mobile_number: 'required',
    password: 'required',
  })

  const formValidatorUserId = useFormValidator(formData, {
    user_id: 'required',
    login_pin: 'required',
  })

  useEffect(() => {
    if (isEmail === 'email') {
      formValidator.onSetObjectRules({
        mobile_number: 'required|email',
        password: "required",
      })
    }
    if (isEmail === 'mobile') {
      formValidator.onSetObjectRules({
        mobile_number: 'required|mobile_number_63',
        password: "required",
      })
    }
    if (isEmail === 'user_id') {
      formValidatorUserId.onSetObjectRules({
        user_id: 'required',
        login_pin: "required",
      })
    }
  }, [isEmail]);

  const handleOnClose = e => {
    e.preventDefault();
    clearAttemp();
    setModal({ isOpen: false });
    setFormData({
      password: "",
      profile_type: "taxpayer",
      otp: "",
      login_type: "credentials",
      mobile_number: "",
      disableResendOTP: false,
      user_id: "",
      login_pin: "",
      preferred_mfa: ""
    });
  };

  const handleOnClickSetting = item => e => {
    e.preventDefault();
    setSelectedMfa(0);
    setFormData({
      ...formData,
      preferred_mfa: item.preferred_mfa,
      title: item.title
    });
  };

  const handleNext = () => {
    if (selectedIndex === 0) {
      setSelectedIndex(1);
    }
  };

  const handleCheckedBox = e => {
    if (e.target.checked) {
      setSelectedMfa(1);
    } else {
      setSelectedMfa(0);
    }
  };

  useEffect(() => {
    if (profile.is_sms_2fa_enabled === true && profile.preferred_mfa === 'sms_otp') {
      setSelectedIndex(1);
    }
  }, []);

  useEffect(() => {
    if (profile.is_email_2fa_enabled === true && profile.preferred_mfa === 'email_otp') {
      setSelectedIndex(1);
    }
  }, []);

  useEffect(() => {
    if (profile.is_google_2fa_enabled === true && profile.preferred_mfa === 'google_authenticator') {
      setSelectedIndex(1);
    }
  }, []);

  const goBack = () => {
    setSelectedIndex(0)
    setSelectedMfa(0);
    setFormData({
      preferred_mfa: ''
    })
  };

  const handleGoBack = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <LoginContainerModal />,
      title: null,
      modalSize: "modal-lg",
      hideHeader: true,
      isCentered: true
    });
  };

  const onCountdown = React.useCallback(() => {
    setIsResendTimerOTP(true);
    setCooldownTime(60);
    localStorage.setItem("cooldownTime", 60);
  }, []);

  const updateCooldown = React.useCallback(() => {
    setCooldownTime((prev) => {
      const newTime = prev - 1;

      if (newTime <= 0) {
        setIsResendTimerOTP(false);
        localStorage.removeItem("cooldownTime");
        return 0;
      }

      localStorage.setItem("cooldownTime", newTime);
      return newTime;
    });
  }, []);

  useEffect(() => {
    if (!isResendTimerOTP) return;

    const timer = setInterval(updateCooldown, 1000);

    return () => clearInterval(timer);
  }, [isResendTimerOTP, updateCooldown]);

  useEffect(() => {
    const storedCooldown = localStorage.getItem("cooldownTime");
    if (storedCooldown && Number.parseInt(storedCooldown, 10) > 0) {
      setCooldownTime(Number.parseInt(storedCooldown, 10));
      setIsResendTimerOTP(true);
      return 0;
    }
  }, []);

  return (
    <Modal.Body className="p-0">
      <div className="login-container">
        <button
          type="button"
          className="close modal-close"
          onClick={handleOnClose}
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div className="container-fluid">
          <div className="row">
            <div className="form-section col-12 col-md-6 d-flex align-items-center">
              <div className="form-content w-100">
                {(selectedIndex === 0) && (
                  <>
                    <div>
                      <div>
                        <button
                          onClick={handleGoBack}
                          type="button"
                          className="mfa-back-button cms-text-primary my-2"
                        >
                          <i className="fas fa-chevron-left mfa-back-login" /> Back
                        </button>
                      </div>
                      <div className="mfa-container">
                        <img
                          src={_.get(CMS_LOGOS, "MAIN_LOGO.cdnUrl")}
                          alt=""
                          className="icon-logo"
                        />
                      </div>
                      <div className=''>
                        <div className="mfa-container">
                          <div className="mfa-title cms-text-primary my-2">Multi-Factor Authentication</div>
                          <div className="mfa-header mb-2">
                            Add an extra layer of security to your account by enabling Multi-Factor Authentication (MFA).
                          </div>
                          <div className="mfa-detail">
                            Select one of the following methods to complete login:
                          </div>
                        </div>
                        <div className="row mt-3">
                          {c.mfaSettings.length > 0 ? (
                            c.mfaSettings
                              .map(item => {
                                return (
                                  <React.Fragment key={item.preferred_mfa}>
                                    <button
                                      key={`module-${item.preferred_mfa}`}
                                      type="button"
                                      onClick={handleOnClickSetting(item)}
                                      className="col-12 btn-blank"
                                    >
                                      <div className={`mfa-card animated fadeIn ${item.preferred_mfa === formData.preferred_mfa ? 'selected-mfa' : ''}`}>
                                        <div className="container-fluid h-100">
                                          <div className="row d-flex align-items-center h-100">
                                            <div className="col-3">
                                              <span className="fa-stack">
                                                <img src={item.preferred_mfa === formData.preferred_mfa ? item.icon_active : item.icon} alt="auth" className="h-auto mx-auto" />
                                              </span>
                                            </div>
                                            <div className="col-9 align-self-center pl-0 text-left">
                                                <span className="title">{item.title}</span>
                                                <div className="description">
                                                  {item.description}
                                                </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </button>
                                  </React.Fragment>
                                );
                              })
                          ) : (
                            <div className="d-flex align-items-center justitfy-content-center h-100">
                              <div className="text-center mx-auto py-4">
                                <img
                                  src={emptyStateImage}
                                  className="img-responsive image-wrapper mb-4 mt-3"
                                  alt="Empty State"
                                />
                                <p className="emp-title mb-0"> No Item Found </p>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="mfa-container d-flex flex-row flex-fill">
                      <input
                        name="change_mfa"
                        type="checkbox"
                        className="button-select"
                        disabled={formData.preferred_mfa === ''}
                        value={selectedMfa}
                        checked={selectedMfa === 0 ? 0 : 1}
                        onChange={handleCheckedBox}
                      />
                      <label className="mfa-detail ml-2 mb-0">Save my choice for future logins</label>
                    </div>
                    <div className='mfa-container'>
                      <div className="d-flex justify-content-center">
                        <button
                          type="button"
                          onClick={handleNext}
                          disabled={selectedIndex === 0 && formData.preferred_mfa === ''}
                          className="btn btn-primary btn-block cms-bg-color-primary cms-outline-primary"
                        >
                          <span className="font-weight-bold">
                            Continue
                          </span>
                        </button>
                      </div>
                    </div>
                  </>
                )}
                {(formData.preferred_mfa === 'email_otp' &&
                  // profile.is_email_2fa_enabled &&
                  selectedIndex !== 0) && (
                    <MultiFactorAuthenticationEmail 
                      profile={profile} 
                      formData={formData} 
                      goBack={goBack} 
                      selectedMfa={selectedMfa} 
                      preferredMfa={formData.preferred_mfa} 
                      onCountdown={onCountdown}
                      isResendTimerOTP={isResendTimerOTP}
                      cooldownTime={cooldownTime}
                    />
                  )}
                {(formData.preferred_mfa === 'google_authenticator' &&
                  // profile.is_google_2fa_enabled &&
                  selectedIndex !== 0) && (
                    <AuthenticatorSetup profile={profile} mfaData={formData} goBack={goBack} selectedMfa={selectedMfa} preferredMfa={formData.preferred_mfa} />
                  )}
                {(formData.preferred_mfa === 'sms_otp' &&
                  // profile.is_sms_2fa_enabled &&
                  selectedIndex !== 0) && (
                    <MultiFactorAuthenticationSms 
                      profile={profile} 
                      formData={formData} 
                      goBack={goBack} 
                      selectedMfa={selectedMfa} 
                      preferredMfa={formData.preferred_mfa} 
                      onCountdown={onCountdown}
                      isResendTimerOTP={isResendTimerOTP}
                      cooldownTime={cooldownTime}
                    />
                  )}
              </div>
            </div>

            <div className="info-section col-12 col-md-6 d-flex align-items-center">
              <div className="info-container">
                <h1 className="info-title font-weight-bold text-light">
                  {_.get(CMS_VARIABLES, "ORGANIZATION")} Local Government System
                </h1>
                {(_.get(CMS_COMPONENTS, "SMART_CITY_HEADER") === false || _.get(CMS_COMPONENTS, "SMART_CITY_HEADER") === undefined) && (
                  serviceList &&
                  serviceList.filter(x => ['E-Government', 'E-Bills', 'E-Commerce', 'E-Services'].indexOf(_.get(x, 'attributes.name')) > -1).map(item => (
                    <div key={item.id} className="row mt-4">
                      <div className="col-3 pr-0">
                        <img
                          src={_.get(item, "attributes.photo")}
                          className="img-responsive"
                          alt="e-gov"
                        />
                      </div>
                      <div className="col-9 mt-4">
                        <h5 className="info-service-title">
                          {_.get(item, "attributes.name")}
                        </h5>
                        <p className="info-service-desc">
                          {_.get(item, "attributes.description")}
                        </p>
                      </div>
                    </div>
                  )))}
                {_.get(CMS_COMPONENTS, "SMART_CITY_HEADER") === true && (
                  serviceList &&
                  serviceList.map(item => (
                    <div key={item.id} className="row mt-4">
                      <div className="col-3 pr-0">
                        <img
                          src={_.get(item, "attributes.photo")}
                          className="img-responsive"
                          alt="e-gov"
                        />
                      </div>
                      <div className="col-9 mt-4">
                        <h5 className="info-service-title">
                          {_.get(item, "attributes.name")}
                        </h5>
                        <p className="info-service-desc">
                          {_.get(item, "attributes.description")}
                        </p>
                      </div>
                    </div>
                  )))}
              </div>
            </div>
          </div>
        </div>
      </div >
    </Modal.Body>
  );
}

MfaModal.defaultProps = {
  profile: {},
};

MfaModal.propTypes = {
  clearAttemp: PropTypes.instanceOf(Function).isRequired,
  serviceList: PropTypes.instanceOf(Array).isRequired,
  profile: PropTypes.instanceOf(Object),
};

const removeENews = res => {
  const newArr = res.filter(d => {
    return (
      d.attributes.name !== "E-Inquiry" &&
      d.attributes.name !== "E-Wallet" &&
      d.attributes.name !== "E-Help" &&
      d.attributes.name !== "E-Government and E-Services"
    );
  });
  return newArr;
};

const mapStateToProps = ({ api }) => ({
  serviceList: removeENews(_.get(api, "SERVICES/get_services", []).list || []),
  profile: JSON.parse(sessionStorage.getItem('enableProfile')),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(MfaModal);
